export default __webpack_public_path__ + "static/media/i-360video.e95832a3.svg";